$(function () {
    
    $('#form-demo').find('input').bind("change paste keydown", function() {
        $(this).parent().removeClass('form__field--success');
        $(this).parent().removeClass('form__field--error');
        $('#form-demo .form__field__submit').prop("disabled", false);
    });

    $('#form-demo').submit(function (event) {
        event.preventDefault();

        $('#notification-demo').html('');
        $('#notification-demo').removeClass('alerts--error');
        $('#notification-demo').removeClass('alerts--success');

        $.ajax({
            url: $(this).attr('action'),
            type: "POST",
            data: new FormData(this),
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (response) {
                if (response.status === "success") {

                    var element = document.getElementById('notification-demo');
                    var offset = 100;
                    var bodyRect = document.body.getBoundingClientRect().top;
                    var elementRect = element.getBoundingClientRect().top;
                    var elementPosition = elementRect - bodyRect;
                    var offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });

                    $('#notification-demo').html('Votre demande de démo a bien été envoyée, vous allez recevoir un accusé de réception par email et nous allons vous contactez dans les plus brefs délais.<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=278729&conversionId=3675297&fmt=gif" />').addClass('alerts--success');
                    $('#form-demo').find('.form__field:not(".form__field--right")').each(function() {
                        $(this).addClass('form__field--success');
                    });

                    $('#form-demo .form__field__submit').prop("disabled", true);

                    // Appvizer
                    (function (w, d, id) {
                        var ts = new Date().getTime();
                        w.avURL = w.avURL || 'https://appvizer.one';
                        w.avPool = w.avPool || [];
                        w.avPool.push({start: ts, id: id});
                        w.av = function () { w.avPool.push(arguments) };
                        var e = document.createElement("script");
                        e.async = true;
                        e.src = w.avURL + '/ariadne/v1/ariadne.js?ts=' + ts;
                        d.getElementsByTagName("head")[0].appendChild(e);
                    })(window, document);
                    av("visit", {id: 'AP-27567'});
                    av("conversion", {id: 'AP-27567'});

                } else if (response.status === "error") {

                    var element = document.getElementById('notification-demo');
                    var offset = 100;
                    var bodyRect = document.body.getBoundingClientRect().top;
                    var elementRect = element.getBoundingClientRect().top;
                    var elementPosition = elementRect - bodyRect;
                    var offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });

                    if (response.reason === "company") {
                        $('#notification-demo').html("Votre demande n'a pas pu être envoyé car le nom de la société n'est pas valide.").addClass('alerts--error');
                        $('#input-company').parent().addClass('form__field--error');
                    } else if (response.reason === "name") {
                        $('#notification-demo').html("Votre demande n'a pas pu être envoyé car le nom indiqué n'est pas valide.").addClass('alerts--error');
                        $('#input-name').parent().addClass('form__field--error');
                    } else if (response.reason === "email") {
                        $('#notification-demo').html("Vous devez indiquer une adresse email valide pour que nous puissions vous répondre.").addClass('alerts--error');
                        $('#input-email').parent().addClass('form__field--error');
                    } else {
                        $('#notification-demo').html("Votre demande n'a pu être envoyé, veuillez rééssayer.").addClass('alerts--error');
                    }

                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr);
                console.log(ajaxOptions);
                console.log(thrownError);
            }
        });
    });

});
